import { createShareVisitLink } from '@higo/api/lib/services/examinationService';
import { useMutation } from 'react-query';
import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import { DoctorMutationKey } from 'config/doctorMutationKey';

export const useCreateShareVisitLinkMutation = () => {
  const { authorizedAxios } = useDoctorPortalApiContext();

  return useMutation(
    [DoctorMutationKey.ExaminationShareLink],
    (visitId: number) => createShareVisitLink(authorizedAxios)(visitId),
  );
};
